import React, { useCallback, useEffect, useState } from "react";


import CustomButton from "../../Components/CustomButton";
import CustomModal from "../../Components/CustomModal";
import FormModal from "../../Components/FormModal";
import Header from "../../Components/Header";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import Loader from '../../Components/Loader';
import usePagination from "../../Hooks/usePagination";
import useSearch from "../../Hooks/useSearch";
import useSelect from "../../Hooks/useSelect";
import useToggle from "../../Hooks/useToggle";
import { useCreatePromoMutation, useDeletePromoMutation, useGetPromosQuery, useUpdatePromoMutation } from "../../Redux/Apis/Promo";
import { dateFormatter } from "../../Utils";
import CustomTable from "./../../Components/CustomTable";
import "./style.css";

const sortValues = [
    {
        text: "Name",
        value: "fullName",
    },
    {
        text: "Email",
        value: "email",
    }
];

const perPageValues = [
    {
        text: "8",
        value: 8,
    },
    {
        text: "15",
        value: 15,
    },
    {
        text: "30",
        value: 30,
    }
];

const maleHeaders = [
    {
        key: "id",
        title: "S.No",
    },
    {
        key: "code",
        title: "Code",
    },
    {
        key: "percentage",
        title: "Discount %",
    },
    {
        key: "used_by",
        title: "Used By",
    },
    {
        key: "expiry",
        title: "Expiry Date",
    },
    {
        key: "actions",
        title: "",
    },
];

const PromoCodes = () => {

    const [showModal, setShowModal] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(perPageValues[0].value);
    const [inputValue, setInputValue] = useState('');
    const [selectedData, setSelectedData] = useState();

    const [formOpen, _, toggleForm] = useToggle()
    const [isEdit, setIsEdit, toggleEdit] = useToggle()
    const [isFilterOpen, setIsFilterOpen, toggleFilter] = useToggle()

    const [sortBy, setSortBy] = useState(sortValues[0].value);
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");

    const [search, debouncedSearch, onSearch] = useSearch()
    const { page, perPage, onNext, onPrevious } = usePagination()
    const { data, isLoading, isFetching, refetch } = useGetPromosQuery({
        page,
        rowsPerPage: perPage,
        search: debouncedSearch,
        sortBy,
        from,
        to
    });
    const [submitPromo, { isSuccess }] = useCreatePromoMutation()
    const [updatePromo, { isSuccess: isUpdated, isLoading: isUpdating }] = useUpdatePromoMutation();
    const [deletePromo, { data: deletedData, isSuccess: isDeleted, isLoading: isDeleting }] = useDeletePromoMutation()

    const { isAllSelected, totalSelected, onSelectAll, onSelectRow, isExists } = useSelect(data?.data)

    useEffect(() => {
        if (isSuccess) {
            toggleForm()
            refetch()
        }
    }, [isSuccess])

    useEffect(() => {
        if (isUpdated) {
            toggleForm()
            refetch()
            setSelectedData()
            toggleEdit()
        }
    }, [isUpdated])

    useEffect(() => {
        if (isDeleted) {
            refetch()
            setSelectedData()
            setShowModal(false)
            setShowModal2(true)
        }
    }, [isDeleted])

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleChange = (e) => {
        setInputValue(e.target.value);
    }

    useEffect(() => {
        document.title = 'Landing List | Promo Codes';
    }, []);

    const onSubmit = data => {

        if (isEdit) {
            updatePromo({ ...data, _id: selectedData._id })
        } else {
            submitPromo(data)
        }

    }

    const onDelete = () => {
        deletePromo(selectedData._id)
    }

    const onToggle = useCallback(() => {
        if (isEdit) {
            toggleEdit()
            setSelectedData()
        }
        toggleForm()
    }, [isEdit, selectedData, formOpen])

    return (
        <>
            <DashboardLayout>
                <div className="container-fluid">
                    <div className="row mb-3">
                        <div className="col-12">
                            <div className="dashCard">
                                <Header
                                    title="Promo Codes"
                                    buttons={[{ label: "Add Promo", onClick: toggleForm, variant: "primaryButton" }]}
                                    length={totalSelected}
                                    search={search}
                                    onSearch={onSearch}
                                    nofilters
                                />
                                <div className="row mb-3">
                                    {
                                        (isLoading || isFetching) ? <Loader /> :
                                            <div className="col-12">
                                                <CustomTable
                                                    headers={maleHeaders}
                                                    isFilterOpen={isFilterOpen}
                                                    dateFilter={false}
                                                    filterSort={false}
                                                    perPage={true}
                                                    filterSortValues={sortValues}
                                                    perPageValues={perPageValues}
                                                    filterSortValue={sortBy}
                                                    setFilterSortValue={setSortBy}
                                                    filterFrom={from}
                                                    setFilterFrom={setFrom}
                                                    filterTo={to}
                                                    setFilterTo={setTo}
                                                    itemsPerPage={itemsPerPage}
                                                    setItemsPerPage={setItemsPerPage}
                                                    length={data?.data?.length}
                                                    isAllSelected={isAllSelected}
                                                    onSelectAll={onSelectAll}
                                                    page={page}
                                                    rowsPerPage={perPage}
                                                    onNext={onNext}
                                                    onPrevious={onPrevious}
                                                    total={data?.total}
                                                >
                                                    <tbody>
                                                        {data?.data?.map((item, index) => (
                                                            <tr key={item._id}>
                                                                {/* <td><input type="checkbox" value={item._id} checked={isExists(item._id)} onClick={() => onSelectRow(item?._id)} /></td> */}
                                                                <td>{(index + 1) + ((currentPage - 1) * itemsPerPage)}</td>
                                                                <td>{item.code}</td>
                                                                <td>{item.percentage} %</td>
                                                                <td>{item?.used_by?.length || "0"}</td>
                                                                <td>{dateFormatter(item?.expiry)}</td>
                                                                <td className="d-flex justify-content-center align-items-center">
                                                                    <CustomButton variant="primaryButton" text="Edit" className="mx-1" onClick={() => { setSelectedData(item), toggleEdit(), toggleForm() }} />
                                                                    <CustomButton variant="dangerButton" text="Delete" className="mx-1" onClick={() => { setSelectedData(item), setShowModal(true) }} />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </CustomTable>
                                            </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <FormModal
                        title={`${isEdit ? "Edit" : "Add"} Promo`}
                        open={formOpen}
                        toggle={onToggle}
                        onSubmit={onSubmit}
                        inputs={[
                            { id: "code", label: "Code", placeholder: "Enter Code", required: true, initialValue: isEdit ? selectedData?.code : "" },
                            { id: "percentage", label: "Percentage", placeholder: "Enter Percentage", required: true, initialValue: isEdit ? selectedData?.percentage : "" },
                            { id: "expiry", label: "Expiry Date", placeholder: "Enter Expiry Date", required: true, type: "date", initialValue: isEdit ? selectedData?.expiry : "" },
                        ]}
                    />
                    <CustomModal loading={isDeleting} show={showModal} close={() => { setShowModal(false) }} action={onDelete} heading='Are you sure you want to delete this promo?' />
                    <CustomModal show={showModal2} close={() => { setShowModal2(false) }} success heading={deletedData?.message} />
                </div >
            </DashboardLayout >
        </>
    );
};

export default PromoCodes